var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcKeyBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9151 42.485L34.2951 28.865C35.6901 25.355 34.9701 21.215 32.1351 18.365C28.6851 14.915 23.3151 14.6 19.4901 17.39L25.2501 23.165L23.1201 25.28L17.3751 19.535C14.5851 23.345 14.9001 28.73 18.3501 32.165C21.1401 34.955 25.2051 35.69 28.6851 34.385L42.3501 48.05C42.9351 48.635 43.8801 48.635 44.4651 48.05L47.9151 44.6C48.5151 44.03 48.5151 43.085 47.9151 42.485ZM43.4151 44.885L29.2251 30.695C28.3101 31.37 27.2901 31.775 26.2251 31.925C24.1851 32.225 22.0401 31.61 20.4801 30.05C19.0551 28.64 18.3951 26.75 18.5001 24.89L23.1351 29.525L29.4951 23.165L24.8601 18.53C26.7201 18.425 28.5951 19.085 30.0201 20.495C31.6401 22.115 32.2551 24.35 31.8801 26.435C31.7001 27.5 31.2501 28.49 30.5601 29.375L44.7351 43.55L43.4151 44.885Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeyBigCircle);
export default __webpack_public_path__ + "static/media/ic_key_big_circle.da45bd65db5817f34f9ff2df3e82ac54.svg";
export { ForwardRef as ReactComponent };